
import { getResultAttributes } from './attributes';
import { updatePagination } from './pagination';
import { ARTICLES, PRODUCTS } from "../constants";

export function buildStateFromModel({
    Filters,
    Results,
    Pagination,
    SearchString,
    OriginalSearchString,
    Recommendations,
    View,
    FindClickTracking,
    Suggestions,
    PromotionalArea,
    ViewName,
    AdditionalBlocks,
    WishlistData,
    DontAutoDirect,
    resultType
}) {
    let results = Results ? Results : [];
    if (resultType == PRODUCTS) {
        for (let i = 0; i < results.length; i++) {
            if (!!results[i].Variations && results[i].Variations.length > 0) {
                for (let o = 0; o < results[i].Variations.length; o++) {
                    results[i].Variations[o].addToListLinkClass = "far fa-bookmark";
                }
            }
        }
    }

    const state = {
        searchString: SearchString,
        originalSearchString: OriginalSearchString,
        results: results,
        attributes: Filters ? getResultAttributes(Filters.Attributes) : [],
        // ???
        showMobileFacets: false,
        // facet
        pagination: updatePagination(Pagination),
        paginationLowestPageIndex: Pagination.CurrentPageIndex,
        paginationFirstItemIndex: Pagination.CurrentPageFirstItemIndex,
        recommendedProducts: Recommendations ? getRecommendedProducts(Recommendations) : [],
        isLoading: false,
        view: View,
        findClickTrackingViewModel: FindClickTracking,
        suggestions: Suggestions,
        promotionalArea: PromotionalArea,
        viewName: ViewName,
        additionalBlocks: AdditionalBlocks,
        wishlistsIninitialized: false,
        wishlistsLoading: false,
        wishlistData: WishlistData,
        addToListModalIsOpen: false,
        addToListVariation: null,
        dontAutoDirect: DontAutoDirect
    };

    return state;
}

function getRecommendedProducts(recommendations) {
    return recommendations.slice(0, 3).map(({ RecommendationId, TileViewModel }) => {
        return {
            RecommendationId,
            name: TileViewModel.name,
            Url: TileViewModel.Url,
            Image: TileViewModel.Image,
            Description: TileViewModel.Description
        };
    });
}